import React from 'react';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { WhatIDoSection } from '../components/WhatIDoSection';
import { HeroTestimonial } from '../components/HeroTestimonial';
import { HowItWorks } from '../components/HowItWorks';
import { SupportingTestimonials } from '../components/SupportingTestimonials';
import { CredibilityBar } from '../components/CredibilityBar';
import { CtaSection } from '../components/CtaSection';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen flex flex-col w-full bg-white font-body" data-id="element-480" data-mp="36qbuq9s658h5">
      <Navigation data-id="element-481" data-mp="36rmzabtfuk9b" />
      <main className="flex-grow" data-id="element-482" data-mp="36s507lr1pmnk">
        <HeroSection data-id="element-483" data-mp="31zbwn17bckd2" />
        <WhatIDoSection data-id="element-484" data-mp="31ytw3sdmbjzc" />
        <HowItWorks data-id="element-485" data-mp="31xiqro4iy464" />
        <HeroTestimonial data-id="element-486" data-mp="2ea12i2kgxo7w" />
        <SupportingTestimonials data-id="element-487" data-mp="2e97uyzdoquop" />
        <CredibilityBar data-id="element-488" data-mp="2e86kaw0l0a7i" />
        <CtaSection data-id="element-489" data-mp="2e7ohthnbszr5" />
      </main>
      <Footer data-id="element-490" data-mp="29bpulxdqhnsb" />
    </div>;
}